import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography, TextField } from "@mui/material";
import RightDrawer from "../RightDrawer";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LogFilterControls from "./LogFilterControls";

const LogFilterPanel = ({
  open,
  onClose,
  filters,
  onFilterChange,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  fieldDefs,
  onClear,
  onApply,
}) => {
  const hasFilters = Object.values(filters).some(
    (arr) => arr && arr.length > 0 && !arr.includes("None")
  );

  return (
    <RightDrawer open={open} onClose={onClose} title="Filter Options">
      <Box className="flex flex-col h-full">
        <LogFilterControls
          filters={filters}
          onChange={onFilterChange}
          fieldDefs={fieldDefs}
        />

        <Box className="p-3 border-t border-gray-300 flex flex-col gap-3">
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              From
            </Typography>
            <ReactDatePicker
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              showTimeSelect
              dateFormat="Pp"
              customInput={<TextField fullWidth label="Select Date & Time" />}
              popperPlacement="bottom-start"
            />
          </Box>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              To
            </Typography>
            <ReactDatePicker
              selected={toDate}
              onChange={(date) => setToDate(date)}
              showTimeSelect
              dateFormat="Pp"
              customInput={<TextField fullWidth label="Select Date & Time" />}
              popperPlacement="bottom-start"
            />
          </Box>

          <Box className="flex gap-2 mt-2">
            {hasFilters && (
              <Button variant="outlined" sx={{ flex: 1 }} onClick={onClear}>
                Clear Filters
              </Button>
            )}
            <Button
              variant="contained"
              sx={{ bgcolor: "#22C55E", color: "white", flex: 2 }}
              onClick={onApply}
            >
              Apply Filters
            </Button>
          </Box>
        </Box>
      </Box>
    </RightDrawer>
  );
};

LogFilterPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  setFromDate: PropTypes.func.isRequired,
  setToDate: PropTypes.func.isRequired,
  fieldDefs: PropTypes.array.isRequired,
  onClear: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default LogFilterPanel;
